module.exports = __webpack_public_path__ + "img/copy.ced020db.svg";